import React, { useState } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, LinkedinIcon, CheckCircle2Icon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { inquiryTypes, profile } from '../data/profile';
export function ContactPortal() {
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [email, setEmail] = useState('');
  const [inquiryType, setInquiryType] = useState(inquiryTypes[0]);
  const [message, setMessage] = useState('');
  const inputClass = 'w-full border border-platinum-300 bg-white px-4 py-3 font-sans text-sm text-navy-900 outline-none transition-colors duration-150 ease-out placeholder:text-charcoal-600/60 focus:border-gold-600';
  const labelClass = 'block font-sans text-xs font-semibold uppercase tracking-[0.14em] text-charcoal-600';
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const subject = `Board inquiry: ${inquiryType} from ${organisation}`;
    const body = [`Name: ${name}`, `Organisation: ${organisation}`, `Email: ${email}`, `Nature of enquiry: ${inquiryType}`, '', 'Details:', message].join('\n');
    window.location.href = `mailto:${profile.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
  };
  return <PageShell path="/contact" data-id="element-273" data-mp="32gn5c9b9coot">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="contact-heading" data-id="element-274" data-mp="32hy6e1dbjic8">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-275" data-mp="2ohx6op8sigyc">
          <div id="direct-contact" className="scroll-mt-24 lg:col-span-5" data-id="element-276" data-mp="2tfyq5ba4oiac">
            <div id="contact-heading" data-id="element-277" data-mp="mqae4j992dzr">
              <SectionHeading eyebrow="Direct Contact" title="Reach Yolandi directly" data-id="element-278" data-mp="mn643593so16" />
            </div>

            <dl className="mt-10 divide-y divide-platinum-200 border-y border-platinum-200" data-id="element-279" data-mp="rlzeupx0a0xn">
              <div className="flex items-center gap-4 py-5" data-id="element-280" data-mp="q4tq2j7g8q1s">
                <MailIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-281" data-mp="l7addnqeglby" />
                <div className="min-w-0" data-id="element-282" data-mp="ga1rbc24rx5f">
                  <dt className={labelClass} data-id="element-283" data-mp="gb37tw1x1buj">Email</dt>
                  <dd className="mt-1 truncate font-sans text-base font-medium text-navy-900" data-id="element-284" data-mp="bayx6mnovbc8">
                    <a href={`mailto:${profile.email}`} className="transition-colors duration-150 ease-out hover:text-gold-600" data-id="element-285" data-mp="18wmj2dmiqb9i">
                      {profile.email}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex items-center gap-4 py-5" data-id="element-286" data-mp="u88jcbkef2x6">
                <PhoneIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-287" data-mp="1rop4s3e0ohqm" />
                <div data-id="element-288" data-mp="1mxp6atp91rm0">
                  <dt className={labelClass} data-id="element-289" data-mp="1mx75rkvk0r8a">Direct line</dt>
                  <dd className="mt-1 font-sans text-base font-medium text-navy-900" data-id="element-290" data-mp="1v632by6yuknn">
                    <a href={`tel:${profile.phone.replace(/\s/g, '')}`} className="transition-colors duration-150 ease-out hover:text-gold-600" data-id="element-291" data-mp="1v85zd26jde1v">
                      {profile.phone}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex items-center gap-4 py-5" data-id="element-292" data-mp="2e5h24wrdmpm2">
                <MapPinIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-293" data-mp="2e2utetsr2429" />
                <div data-id="element-294" data-mp="2i4g202y93w6n">
                  <dt className={labelClass} data-id="element-295" data-mp="2mx956me2mwgm">Based in</dt>
                  <dd className="mt-1 font-sans text-base font-medium text-navy-900" data-id="element-296" data-mp="2mxsr0e6ue4zx">
                    {profile.location}
                  </dd>
                </div>
              </div>
            </dl>

            <a href={profile.linkedIn} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center justify-center gap-2.5 whitespace-nowrap bg-navy-900 px-6 py-3.5 font-sans text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-navy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-600" data-id="element-297" data-mp="2wwzzoo2mtbgp">
              <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-298" data-mp="76zeepi82k9d" />
              Connect on LinkedIn
            </a>

            <p className="mt-10 border-l-2 border-gold-500 pl-5 font-sans text-base leading-relaxed text-charcoal-700" data-id="element-299" data-mp="3fnu75c5b2o9q">
              {profile.disclaimer}
            </p>
          </div>

          <div id="inquiry" className="scroll-mt-24 lg:col-span-7" data-id="element-300" data-mp="3oos81lkg6fo3">
            <div className="border border-platinum-200 bg-platinum-100 p-8 lg:p-10" data-id="element-301" data-mp="3kmdqr5wffnyx">
              <h2 className="font-display text-xl font-bold tracking-tight text-navy-900" data-id="element-302" data-mp="13xi25swn1t2a">
                Board inquiry
              </h2>
              <p className="mt-3 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-303" data-mp="zuv6ti0rdq0c">
                Submit a confidential enquiry regarding a directorship, advisory mandate or executive
                appointment. Submitting composes the enquiry as an email addressed directly to{' '}
                {profile.email}, and responses are typically provided within two business days.
              </p>

              {submitted ? <div role="status" className="mt-8 flex items-start gap-4 border border-gold-500 bg-white p-6" data-id="element-304" data-mp="12ifbyumavjmr">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-305" data-mp="1v3yr3na0x370" />
                  <div data-id="element-306" data-mp="1gfce3s7vcniy">
                    <p className="font-display text-base font-bold text-navy-900" data-id="element-307" data-mp="1ge19xraihdrb">Inquiry prepared</p>
                    <p className="mt-2 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-308" data-mp="1ld424b5e7phv">
                      Thank you, {name || 'and welcome'}. Your enquiry has been addressed to{' '}
                      {profile.email} in your email client. Send it there and a response will follow
                      to the address provided.
                    </p>
                    <button type="button" onClick={() => setSubmitted(false)} className="mt-4 font-sans text-sm font-semibold text-gold-600 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-navy-900" data-id="element-309" data-mp="2itgdzhac77xy">
                      Submit another enquiry
                    </button>
                  </div>
                </div> : <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-310" data-mp="1v2svy36pj1xo">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-311" data-mp="1v0q6plddpcu0">
                    <div data-id="element-312" data-mp="1r2in8irj5xf4">
                      <label className={labelClass} htmlFor="inquiry-name" data-id="element-313" data-mp="1qz4odki2s6cf">
                        Full name
                      </label>
                      <input id="inquiry-name" name="name" required value={name} onChange={event => setName(event.target.value)} className={`mt-2 ${inputClass}`} placeholder="Jane Director" data-id="element-314" data-mp="1h2i5305ednci" />
                    </div>
                    <div data-id="element-315" data-mp="al1w9vqig8c4">
                      <label className={labelClass} htmlFor="inquiry-organisation" data-id="element-316" data-mp="ak8melw992pr">
                        Organisation
                      </label>
                      <input id="inquiry-organisation" name="organisation" required value={organisation} onChange={event => setOrganisation(event.target.value)} className={`mt-2 ${inputClass}`} placeholder="Board or company name" data-id="element-317" data-mp="3eyqiraqhel60" />
                    </div>
                  </div>

                  <div data-id="element-318" data-mp="2v8mv4sg1j4o6">
                    <label className={labelClass} htmlFor="inquiry-email" data-id="element-319" data-mp="1onf1nq04xz6o">
                      Email address
                    </label>
                    <input id="inquiry-email" name="email" type="email" required value={email} onChange={event => setEmail(event.target.value)} className={`mt-2 ${inputClass}`} placeholder="name@organisation.com" data-id="element-320" data-mp="1jpvoktf6bsgb" />
                  </div>

                  <div data-id="element-321" data-mp="22llswnakx0xd">
                    <label className={labelClass} htmlFor="inquiry-type" data-id="element-322" data-mp="2hcvswkc0ra1b">
                      Nature of enquiry
                    </label>
                    <select id="inquiry-type" name="inquiryType" value={inquiryType} onChange={event => setInquiryType(event.target.value)} className={`mt-2 ${inputClass}`} data-id="element-323" data-mp="2cdrm20ckhoe5">
                      {inquiryTypes.map(type => <option key={type} value={type} data-id="element-324" data-mp="39zcb307qfrs1">
                          {type}
                        </option>)}
                    </select>
                  </div>

                  <div data-id="element-325" data-mp="30xmivs610ot7">
                    <label className={labelClass} htmlFor="inquiry-message" data-id="element-326" data-mp="30wt9skjlhn7w">
                      Details
                    </label>
                    <textarea id="inquiry-message" name="message" required rows={5} value={message} onChange={event => setMessage(event.target.value)} className={`mt-2 resize-y ${inputClass}`} placeholder="Mandate, timing and any relevant context." data-id="element-327" data-mp="2m75bls6pn4oe" />
                  </div>

                  <button type="submit" className="inline-flex w-full items-center justify-center whitespace-nowrap bg-gold-500 px-6 py-3.5 font-sans text-sm font-semibold text-navy-950 transition-colors duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-600 sm:w-auto" data-id="element-328" data-mp="288xhds126hgx">
                    Submit board inquiry
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </section>
    </PageShell>;
}